import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: Infinity,
      throwOnError: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
})

export default queryClient
